import { colors } from '../../Colors/colors'

export const operationsHubTheme = {
   light: {
      common: {
         alertTextColor: 'text-gray-800',
         tooltip: {
            backgroundColor: 'bg-gray-900'
         }
      },
      exportPipelineItemsRequestModal: {
         closeIconColor: colors['gray-500'],
         titleTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600',
         includeAllContactFieldsButtonTextColor: 'text-gray-700',
         exportAsTextColor: 'text-gray-700',
         exportAsOptionTextColor: 'text-gray-700',
         exportSelectedFieldsBackgroundColor: 'bg-gray-50',
         exportSelectedFieldsBorderColor: 'border-gray-100',
         noResultsTextColor: 'text-gray-500'
      },
      exportedDataField: {
         fileNameTextColor: 'text-gray-600',
         dateTextColor: 'text-gray-600',
         downloadIconFillColor: colors['primary-600'],
         refreshIconFillColor: colors['error-700'],
         emptyCellTextColor: 'text-gray-600',
         failureViewTextColor: 'text-gray-600',
         inProgressTextColor: 'text-warning-600',
         expiredTextColor: 'text-gray-600'
      },
      exportedDataHeader: {
         titleTextColor: 'text-gray-900',
         header: 'bg-base-white border-gray-300'
      },
      pushNotificationCard: {
         cardBorderColor: 'border-gray-100',
         usersIconColor: colors['primary-600'],
         usersIconInnerBGColor: colors['primary-100'],
         usersIconOuterBGColor: colors['primary-50'],
         closeIconColor: colors['gray-500'],
         arrowIconColor: colors['primary-600'],
         refreshIconFillColor: colors['error-700'],
         downloadIconFillColor: colors['primary-600'],
         successIconFillColor: colors['success-600']
      },
      exportActivityLogs: {
         headerTitleColor: 'text-gray-900',
         headerDescriptionColor: 'text-gray-500',
         InputLabelTextColor: 'text-gray-700',
         fileInputElementColor: 'text-gray-900',
         datePickerInputColor: 'text-gray-500'
      },
      activityLogs: {
         headerBorderColor: 'border-gray-300',
         headerTitleColor: 'text-gray-900',
         refreshIconColor: colors['gray-700']
      },
      uploadActivities: {
         headerBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         closeIconColor: colors['gray-500'],
         labelTextColor: 'text-gray-700',
         linkTextColor: 'text-primary-500'
      },
      header: {
         titleColor: 'text-gray-900',
         containerBGColor: 'bg-white',
         refreshIconBGColor: '!bg-white',
         disabledIconColor: colors['gray-600'],
         enabledIconColor: colors['primary-600'],
         borderColor: 'border-gray-300'
      },
      usersTheme: {
         headerBorderColor: 'border-gray-300',
         searchBarIconFillColor: colors['gray-500'],
         createUser: {
            containerBGColor: 'bg-base-white',
            headerBGColor: 'bg-base-white',
            headerTextColor: 'text-gray-900',
            isAdminTextColor: 'text-gray-700',
            labelTextColor: 'text-gray-700'
         },
         updateUser: {
            defaultBGColor: 'bg-white',
            defaultBorderColor: 'border-gray-300',
            defaultToggleSwitchBgColor: colors['gray-100'],
            headerTextColor: 'text-gray-900',
            labelTextColor: 'text-gray-700',
            closeIconFillColor: colors['gray-500'],
            fieldsContainerBGColor: 'bg-white',
            collapseCardTextColor: 'text-gray-900',
            chevronIconColor: colors['gray-500'],
            chevronButtonHoverBGColor: 'hover:bg-gray-50',
            descriptionTextColor: 'text-gray-500',
            fieldValueTextColor: 'text-gray-800',
            agentCardOnHoverColor: 'hover:bg-gray-50',
            bgTransparentColor: '!bg-transparent',
            managerCardHoverColor: 'hover:bg-gray-100'
         },
         errorView: {
            containerBGColor: 'bg-gray-100',
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600'
         }
      },
      createRole: {
         headerTextColor: 'text-gray-900',
         fieldLabelTextColor: 'text-gray-700'
      },
      crateRoleModal: {
         closeIconColor: colors['gray-500']
      },
      sidePaneHeader: {
         titleColor: 'text-gray-900',
         closeIconColor: colors['gray-500']
      },
      createUserGroup: {
         titleColor: 'text-gray-900',
         closeIconColor: colors['gray-500']
      },
      updateUserGroup: {
         fieldValueColor: 'text-gray-900',
         fieldLabelColor: 'text-gray-700'
      },
      rolesController: {
         fieldLabelTextColor: 'text-gray-900'
      },
      exportUsers: {
         headerBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         defaultBGColor: 'bg-base-white'
      },
      uploadLeads: {
         iconColor: colors['base-white'],
         borderColor: 'border-gray-300',
         defaultBorderColor: 'border-gray-300',
         customOptionHoverBgColor: 'hover:bg-gray-50',
         customOptionBgColor: 'bg-primary-50',
         tickIconColor: colors['primary-600'],
         headerTitleColor: 'text-gray-900',
         defaultDescriptionColor: 'text-gray-700',
         refreshIconColor: colors['gray-700'],
         selectedContactOptionBGColor: 'bg-gray-50',
         notSelectedContactOptionBGColor: 'bg-white',
         customOptionTextColor: 'text-gray-900',
         customOptionSupportTextColor: 'text-gray-600'
      },
      contactImportLogs: {
         header: {
            headerBGColor: 'bg-white',
            borderColor: 'border-gray-300',
            headerTextColor: 'text-gray-900',
            headerBorderColor: 'border-gray-300'
         },
         table: {
            headerTextColor: 'text-gray-900',
            containerBGColor: 'bg-gray-100'
         },
         uploadContacts: {
            closeIconFillColor: colors['gray-500'],
            containerBGColor: 'bg-base-white',
            defaultBorderColor: 'border-gray-300',
            defaultDescriptionColor: 'text-gray-700',
            headerTextColor: 'text-gray-900',
            badgeCloseIconColor: colors['primary-600'],
            customOptionHoverBgColor: 'hover:bg-gray-50',
            selectedContactOptionBGColor: 'bg-gray-50',
            notSelectedContactOptionBGColor: 'bg-white',
            customOptionTextColor: 'text-gray-900',
            customOptionSupportTextColor: 'text-gray-600'
         }
      },
      uploadUsers: {
         defaultBorderColor: 'border-gray-300',
         headerBorderColor: 'border-gray-300',
         headerTitleColor: 'text-gray-900',
         defaultDescriptionColor: 'text-gray-700',
         iconColor: colors['base-white']
      },
      usersFilterSidePane: {
         borderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900'
      },
      bulkActions: {
         updateManager: {
            popoverBgColor: 'bg-base-white'
         }
      },
      clockInConfig: {
         routeBackgroundColor: 'bg-gray-100',
         headerBackgroundColor: 'bg-white',
         headerBorderColor: 'border-gray-300',
         headingFontColor: 'text-gray-900',
         clockInFeatureStatusContainer: {
            backgroundColor: 'bg-white',
            mainTextFontColor: 'text-gray-700',
            helpTextFontColor: 'text-gray-700'
         },
         defaultResetTimeContainer: {
            backgroundColor: 'bg-white',
            mainTextFontColor: 'text-gray-700',
            helpTextFontColor: 'text-gray-700',
            timeTextFontColor: 'text-gray-700'
         }
      }
   },
   dark: {}
}
